import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ValidationsDialogComponent } from './validations-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ValidationDialogService {
  constructor(private dialog: MatDialog, private translate: TranslateService) {}

  handleError(error) {
    if (error?.error) {
      if (error?.error?.problemList || error?.error?.reasons || error?.error?.detail) {
        this.dialog.open(ValidationsDialogComponent, {
          data: {
            message: error.error,
          },
        });
      } else if (
        (error?.error?.Errors || error?.error?.error || error?.error?.Error) &&
        !error?.hasOwnProperty('message')
      ) {
        if (error?.error?.error) {
          const respMsg = 'Deleting will also unlink all the pieces. Do you want to continue?';
          if (!error.error.error.includes(respMsg)) {
            this.dialog.open(ValidationsDialogComponent, {
              data: {
                message: error.error.error,
              },
            });
          }
        } else {
          const msg = error?.error?.Errors ? error.error.Errors : error?.error?.Error;
          this.dialog.open(ValidationsDialogComponent, {
            data: {
              message: msg,
            },
          });
        }
      } else if (error?.error?.message || error?.error?.Message) {
        const msg = error?.error?.Message?.status
          ? error.error.Message.status
          : error.error.Message;
        const pattern = /(Shipment IDs|货件ID)\s+\d+/;
        if (!pattern.test(msg)) {
          this.dialog.open(ValidationsDialogComponent, {
            data: {
              message: error?.error?.message ? error?.error?.message : msg,
            },
          });
        }
      } else if (typeof error.error === 'string' && this.parseStringValidJson(error.error)) {
        let msg;
        if (JSON.parse(error.error)?.message || JSON.parse(error.error)?.Message) {
          msg = JSON.parse(error.error)?.message
            ? JSON.parse(error.error)?.message
            : JSON.parse(error.error)?.Message;
        } else {
          msg = 'alert.errorOccurred';
        }
        this.dialog.open(ValidationsDialogComponent, {
          data: {
            message: JSON.parse(error.error)?.Error
              ? JSON.parse(error.error)?.Error
              : this.translate.instant(msg),
          },
        });
      } else {
        // let err;
        // err = typeof error.error === 'object' ? JSON.stringify(error.error) : error.error;
        this.dialog.open(ValidationsDialogComponent, {
          data: {
            message: error?.error ? error.error : this.translate.instant('alert.serviceError'),
          },
        });
      }
    } else {
      // this.dialog.open(ValidationsDialogComponent, {
      //   data: {
      //     message: error?.statusText ? error.statusText : 'Error Occurred',
      //   },
      // });
    }
  }
  parseStringValidJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}
